import { type ComponentProps } from 'react';

import { PlusIcon } from '@air/design-icons';
import { IconButton } from '@air/primitive-icon-button';

export type BoardSelectListHeaderProps = ComponentProps<'h2'> & {
  onCreate?: () => void;
};

export const BoardSelectListHeader = ({ children, onCreate }: BoardSelectListHeaderProps) => {
  return (
    <h2 className="flex h-6 shrink-0 items-center justify-between gap-2 px-2 font-bold ads:text-metadata text-12 text-gray-9 uppercase tracking-wider">
      {children}

      {!!onCreate && (
        <IconButton
          adsIcon
          appearance="ghost"
          color="gray"
          icon={PlusIcon}
          label="Create new"
          onClick={onCreate}
          size="small"
        />
      )}
    </h2>
  );
};
